module.exports = __webpack_public_path__ + "static/media/adserver_section1.3ede7e83.png";